import React, { useEffect, useRef } from "react";
import { setShowWorkflowHeader } from "src/store/workflowSlice";
import { useAppDispatch } from "src/store/store";

interface ContainerCountStepProps {
  humanText: string;
  onComplete: (data: { drumCount: number }) => void;
}

/**
 * Container-count step (`get_drum_count`).
 *
 * The container inspection loop is now open-ended for every flow: the inspector
 * ends it manually via "All Containers Finished" instead of committing to a
 * fixed count up front. So this step no longer prompts the user to type a
 * count — it just shows the workflow header and advances straight into the
 * loop.
 *
 * `drumCount` is still passed to `onComplete` to keep the workflow-config step
 * shape stable, but it is no longer used by the (open-ended) iterate step.
 */
const ContainerCountStep: React.FC<ContainerCountStepProps> = ({
  onComplete,
}) => {
  const dispatch = useAppDispatch();
  const onCompleteRef = useRef(onComplete);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  useEffect(() => {
    dispatch(setShowWorkflowHeader(true));
    onCompleteRef.current({ drumCount: 1 });
  }, [dispatch]);

  return null;
};

export default ContainerCountStep;
